import { render, staticRenderFns } from "./HeroSectionFilters.vue?vue&type=template&id=153b11ae&scoped=true&"
import script from "./HeroSectionFilters.vue?vue&type=script&lang=js&"
export * from "./HeroSectionFilters.vue?vue&type=script&lang=js&"
import style0 from "./HeroSectionFilters.vue?vue&type=style&index=0&id=153b11ae&prod&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153b11ae",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppImg: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppImg.vue').default})
